import React,{lazy,Suspense, useState, useEffect} from 'react'
import Cargando from '../Externo/Cargando';
import AppDevice from '../../Class/device'
const Visor = lazy(() => import('../NuevoVisor/Visor'));

function Local(props) {
  const [study, setstudy] = useState(null)
  console.log('Local',props)
  useEffect(() => {
    async function init(){
      let estudio = await fetch(`${AppDevice.ServerUrl}/study/${props.match.params.id}`)
      estudio = await estudio.json()
      console.log('estudio',estudio)
      setstudy(estudio)
    }
    init()
  }, [])
  return (
    <Suspense fallback={<Cargando mensaje="Inicializando Visor"/>}>
    {study?<Visor {...props} estudio={study}/>:<Cargando mensaje="Inicializando Visor"/>}
    </Suspense>
  )
}

export default Local